import { settings } from '@alme/ui-web/settings/settings-util';
import { AlightCustomSettingsType } from "../../../settings/alight-custom-settings";
import { sendRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
//@ts-ignore
import * as postMessageUtilities from '@alme/ui-web/modules/lib-postmessage/lib/lib-postmessage';
import { Store } from 'redux';
import { AlightStateType } from '../../../types/alight-state';
import { Input } from '@alme/ui-web/types/input';
import {setMinimize} from "@alme/ui-web/modules/window-minimize/src/actions/actions";

export default class SimplifiedAeFlowProcessUpdatePostMessage
{
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | null = null;
    
    constructor(passedSettings: AlightCustomSettingsType)
    {
        this._settings = passedSettings || settings;
    }

    initialize(store: Store<AlightStateType>): void
    {
        this._store = store;
        postMessageUtilities.setupStateWatchForReceivedMessages(this._settings, this._store, this.processPostMessage.bind(this));
    }

    getReducer() {
        return (state = {}): {} => { return state; };
    }

    getPromise(): Promise<void>
    {
        return new Promise((resolve) => {
            resolve();
        });
    }

    processPostMessage(newVal: any): void
    {
        const msg = postMessageUtilities.getAndValidateMessage(newVal, 'simplifiedaeflowprocessupdate');

        if (msg === null)
        {
            return;
        }

        if(postMessageUtilities.isActiveSession(this._settings, this._store)){

            const varName = msg.message?.Data?.variableName; 
            const varValue = msg.message?.Data?.variableValue; 
            const state = this._store?.getState();
            
            const input = {
                messageType : this._settings.messageConstants.appeventRequest,
                eventName : this._settings.appeventConstants.simplifiedAeFlowProcessUpdate,
                origin : this._settings.originConstants.internal,
                parameters: {
                    VariableName: varName,
                    VariableValue: varValue,
                },
            };

            sendRequest(input as Input);

            if(state && state.Window?.IsMinimized){
                this._store?.dispatch(setMinimize(false, this._settings.stateLocations.Window.IsMinimized));
            }
        }

        postMessageUtilities.setIsProcessed(this._settings, this._store, msg.message);
        
        return;
    }
}


// WEBPACK FOOTER //
// ./modules/simplified-annual-enrollment-post-message-handlers/src/simplifiedAeFlowProcessUpdatePostMessage.ts